import { navigation } from "@src/navigation";
import { Navigate, useParams } from "react-router";

export default function PatientIndexRedirect() {
  const { patientId } = useParams();

  if (!patientId) {
    return null;
  }

  return <Navigate to={navigation.patientBriefing(patientId)} replace />;
}
